// extracted by mini-css-extract-plugin
module.exports = {"Container":"Complaint_Container__2Cfxo","form":"Complaint_form__Ub5d-","Submit":"Complaint_Submit__1ltGR","Error":"Complaint_Error__3Sg1G"};